export const getPreviousSlideIndex = (currentIndex: number) =>
    currentIndex === 0 ? 2 : currentIndex - 1;

export const getNextSlideIndex = (currentIndex: number) =>
    currentIndex === 2 ? 0 : currentIndex + 1;
